var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import ReactDOM from "react-dom";
export function render(element) {
    try {
        ReactDOM.render(element, document.querySelector("#react-root"), removeSplash);
    }
    catch (error) {
        // show the error using the class defined in the template
        // this can obviously be improved
        ReactDOM.render((React.createElement("div", { className: "splash-error" },
            React.createElement("h1", null, "Failed to load application"),
            React.createElement("p", null, "An error occurred while loading the application. Please make sure you are using a current browser version."))), document.body);
    }
}
export function removeSplash() {
    return __awaiter(this, void 0, void 0, function* () {
        // wait for fonts to become ready
        if (document.fonts) {
            yield document.fonts.ready;
        }
        const preloader = document.querySelector("#splash");
        if (preloader) {
            preloader.classList.add("fadeout");
            setTimeout(() => { var _a; return (_a = preloader.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(preloader); }, 500);
        }
    });
}
//# sourceMappingURL=index.js.map